module.exports = __webpack_public_path__ + "media/images/social-share-button/twitter-59f61548d71b77b5144f030f0b705a72.svg";